var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
var CustomerSampleCSV = /** @class */ (function () {
    function CustomerSampleCSV() {
    }
    CustomerSampleCSV.prototype.getHeaderOptions = function (data) {
        var customerOptions;
        customerOptions = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            showTitle: false,
            headers: getHeaders(data)
        };
        return customerOptions;
    };
    CustomerSampleCSV.prototype.getDataOption = function (domain) {
        if (domain === 'app.xquara.co') {
            var xquaraData = void 0;
            xquaraData = [
                {
                    customerName: 'customer_name',
                    email: 'customer@gmail.com',
                    code: '965',
                    phone: '87654432',
                    address: 'Street 6, Salwa, Kuwait',
                    latitude: '29.3018786',
                    longitude: '48.07849059999999'
                }, {
                    customerName: 'customer_name',
                    email: 'customer@gmail.com',
                    code: '965',
                    phone: '87654432',
                    address: 'Street 6, Salwa, Kuwait',
                    latitude: '',
                    longitude: ''
                }
            ];
            /*if (this.isDriverPinCode) {
              Object.assign(driverData[0], {'pincode': 560097});
            }*/
            return xquaraData;
        }
        else {
            var customerData = void 0;
            customerData = [
                {
                    customerName: 'ramachandra',
                    email: 'rcrmca1@gmail.com',
                    code: '91',
                    phone: '9030263982',
                    address: 'marthahalli',
                    latitude: '12.427680',
                    longitude: '76.451653'
                }, {
                    customerName: 'riya',
                    email: 'riya@gmail.com',
                    code: '91',
                    phone: '9964202691',
                    address: 'yeshwanthpur',
                    latitude: '',
                    longitude: ''
                }
            ];
            /*if (this.isDriverPinCode) {
              Object.assign(driverData[0], {'pincode': 560097});
            }*/
            return customerData;
        }
    };
    CustomerSampleCSV = __decorate([
        Injectable()
    ], CustomerSampleCSV);
    return CustomerSampleCSV;
}());
export { CustomerSampleCSV };
function getHeaders(title) {
    var defaultHeaderArr;
    if (title === 'importOption') {
        defaultHeaderArr = ['Customer_name', 'Email', 'Country_code*', 'Phone*', 'Address*', 'Latitude', 'Longitude'];
        /*if (isDriverPinCode) {
          defaultHeaderArr.push('Pincode');
        }
        if (emailRequired) {
          defaultHeaderArr[3] = 'Email*';
        }*/
    }
    else {
        defaultHeaderArr = ['Customer_name', 'Email', 'Phone', 'Address'];
        /* if (isDriverPinCode) {
           defaultHeaderArr.push('Pincode');
         }*/
    }
    return defaultHeaderArr;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/customer/customerSampleCSV.ts
// module id = ./src/app/customer/customerSampleCSV.ts
// module chunks = main